export default __webpack_public_path__ + "assets/webgl/Catalogue.ce3a5d4f.glb";